import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'

import { ASN } from './ASN'
import { Client } from './Client'

export enum BatchType {
  batch = 'batch',
  lot = 'lot',
  po = 'po',
}

export class Batch {
  static Type = BatchType

  static type = 'batch'
  type = Batch.type

  guid: string = ''

  @Type(() => Client)
  client?: Client

  @Expose({ name: 'batch_type' })
  batchType: BatchType = BatchType.batch

  static batchTypeMap = {
    [BatchType.batch]: 'Batch',
    [BatchType.lot]: 'Lot',
    [BatchType.po]: 'Purchase Order',
  }

  get batchTypeDisplay() {
    return Batch.batchTypeMap[this.batchType]
  }

  @Expose({ name: 'client_uid' })
  clientId: string = ''

  @Expose({ name: 'expires_on' })
  @Transform((value) => (value ? moment(value) : value))
  expiresOn?: moment.Moment

  @Type(() => ASN)
  asn?: ASN

  get name() {
    return `${this.batchTypeDisplay} #${this.clientId}`
  }
}
